import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

const videoYoutube = process.env.NODE_ENV === 'test' ? () => null : require('videojs-youtube')

export default class NRTVideo extends React.Component {

    state = {
        videoSrc: null
    }

    initialized = false


    componentDidMount() {
        this.initVideo()
    }


    componentDidUpdate(prevProps) {
        if (prevProps.videoSrc !== this.props.videoSrc)
            this.player.src({src: this.props.videoSrc})

    }


    componentWillUnmount() {
        this.dispose()
    }


    initVideo() {

        this.dispose()
        const isYoutubeVideo = !this.props.videoSrc.includes('amazonaws')

        const props = {
            controls: true,
            playbackRates: [0.5, 1, 1.5, 2],
            fluid: true,
            aspectRatio: '16:9',
            autoplay: this.props.autoplay,
            techOrder: ["html5", "youtube"],
            sources: [
                {

                    type: isYoutubeVideo ? "video/youtube" : "video/mp4",
                    src: this.props.videoSrc
                }
            ],
            ...this.props.videoOptions,
        }


        this.player = videojs(this.videoNode, props, function onPlayerReady() {


        })

        this.player.on('ratechange', this.props.onRateChange)
        this.player.on('useractive', this.props.onUserActive)
        this.player.on('userinactive', this.props.onUserInactive)
        this.player.on('play', this.props.onPlay)
        this.player.on('ended', this.props.onEnd)
        this.player.on('seeked', this.props.onSeeked)


        this.addButtonsToVideo()

    }


    addButtonsToVideo() {
        const self = this

        const SkipFifteenSeconds = this.createButton(
            'Pular 15s',
            'icon-skip-15',
            () => {
                self.player.currentTime(self.player.currentTime() + 15);
            }
        )

        videojs.registerComponent('SkipFifteenSeconds', SkipFifteenSeconds);

        const BackFifteenSeconds = this.createButton(
            'Voltar 15s',
            'icon-back-15',
            () => {
                self.player.currentTime(self.player.currentTime() - 15);
            }
        )

        videojs.registerComponent('SkipFifteenSeconds', SkipFifteenSeconds);
        videojs.registerComponent('BackFifteenSeconds', BackFifteenSeconds);


        const controlBar = this.player.getChild('controlBar')

        controlBar.addChild('SkipFifteenSeconds', {}, 2)
        controlBar.addChild('BackFifteenSeconds', {}, 1)


    }


    createButton(text, className, onClick) {
        const Button = videojs.getComponent('Button')
        return videojs.extend(Button, {
            //constructor: function(player, options) {
            constructor: function () {
                Button.apply(this, arguments);
                this.addClass(className);
                this.controlText(text);

            },

            handleClick: onClick
        })
    }


    dispose() {
        if (this.player)
            this.player.dispose()
    }


    render() {


        return (


            <div data-vjs-player className={'nrt-video'}>
                <video ref={node => this.videoNode = node}
                       className="video-js"/>
            </div>


        )
    }
}

NRTVideo.propTypes = {

    autoplay: PropTypes.bool,
    videoOptions: PropTypes.object,
    videoSrc: PropTypes.string.isRequired,
    onUserActive: PropTypes.func,
    onUserInactive: PropTypes.func,
    onRateChange: PropTypes.func,
    onEnd: PropTypes.func,
    onPlay: PropTypes.func,
    onSeeked: PropTypes.func,


}

NRTVideo.defaultProps = {
    autoplay: false,
    videoOptions: {},
    onUserActive: () => null,
    onUserInactive: () => null,
    onRateChange: () => null,
    onEnd: () => null,
    onPlay: () => null,
    onSeeked: () => null,
}



// WEBPACK FOOTER //
// ./src/components/_ead/VideojsWrapper/index.js